import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, TextField, Typography } from '@mui/material';

import LocationSparkleIcon from '../../../../assets/icons/LocationSparkleIcon';
import DateTimeInputMaskedField from '../../../../components/DateTimeInputMaskedField/DateTimeInputMaskedField';
import { BLACK, FEED_BACK } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';
import { isValidNumber } from '../../../../utils';

const HistoryTimeFields = ({
  labelKey,
  clockInEpoch,
  clockOutEpoch,
  breakTime,
  dailyHours,
  showClockInAutoPunch,
  showClockOutAutoPunch,
}) => {
  const clockInBorderColor = showClockInAutoPunch ? FEED_BACK.GREEN_70 : BLACK[100];
  const clockOutBorderColor = showClockOutAutoPunch ? FEED_BACK.GREEN_70 : BLACK[100];

  const clockInFieldStyles = {
    '& label.Mui-focused': {
      color: clockInBorderColor,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: clockInBorderColor,
      },
      '&:hover fieldset': {
        borderColor: clockInBorderColor,
      },
      '&.Mui-focused fieldset': {
        borderColor: clockInBorderColor,
      },
    },
  };
  const clockOutFieldStyles = {
    '& label.Mui-focused': {
      color: clockOutBorderColor,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: clockOutBorderColor,
      },
      '&:hover fieldset': {
        borderColor: clockOutBorderColor,
      },
      '&.Mui-focused fieldset': {
        borderColor: clockOutBorderColor,
      },
    },
  };

  const AutoPunchIndicator = () => (
    <Box display="flex" alignItems="center" gap="8px" mt="8px">
      <LocationSparkleIcon width={20} height={20} />
      <Typography
        style={{
          fontFamily: PRIMARY_FONT[400],
          fontSize: '14px',
          color: FEED_BACK.GREEN_70,
        }}
      >
        {LanguageConverterV2('timekeeping.workerTimecard.timecardHistoryCard.autoPunch')}
      </Typography>
    </Box>
  );

  return (
    <Box sx={{ pr: '8px', pl: '8px' }}>
      <Box display="flex" alignItems="start" gap="24px" flexWrap="wrap">
        <Typography sx={{ alignSelf: 'center', width: '80px' }}>
          {LanguageConverterV2(labelKey) || '--'}
        </Typography>
        <Box sx={{ width: '220px' }}>
          <DateTimeInputMaskedField
            label={LanguageConverterV2(
              'timekeeping.workerTimecard.timecardHistoryCard.timeFieldLabel.clockIn'
            )}
            value={clockInEpoch ? new Date(clockInEpoch) : null}
            readOnly
            customStyles={clockInFieldStyles}
          />
          {showClockInAutoPunch && clockInEpoch && <AutoPunchIndicator />}
        </Box>
        <Box sx={{ width: '220px' }}>
          <DateTimeInputMaskedField
            label={LanguageConverterV2(
              'timekeeping.workerTimecard.timecardHistoryCard.timeFieldLabel.clockOut'
            )}
            value={clockOutEpoch ? new Date(clockOutEpoch) : null}
            readOnly
            customStyles={clockOutFieldStyles}
          />
          {showClockOutAutoPunch && clockOutEpoch && <AutoPunchIndicator />}
        </Box>
        <Box sx={{ width: '120px' }}>
          <TextField
            id="break-time-read-only-input"
            label={LanguageConverterV2(
              'timekeeping.workerTimecard.timecardHistoryCard.timeFieldLabel.break'
            )}
            defaultValue={isValidNumber(breakTime) ? (breakTime / 60 / 1000).toFixed(0) : '--'}
            InputProps={{
              readOnly: true,
              sx: {
                color: BLACK[70],
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: BLACK[100],
                },
              },
            }}
            InputLabelProps={{
              sx: {
                '&.Mui-focused': {
                  color: BLACK[100],
                },
              },
            }}
            focused
          />
        </Box>
        <Box sx={{ width: '220px' }}>
          <Typography
            style={{
              fontFamily: PRIMARY_FONT[500],
              fontSize: '16px',
            }}
          >
            {LanguageConverterV2(
              'timekeeping.workerTimecard.timecardHistoryCard.timeFieldLabel.dailyHours'
            )}
          </Typography>
          <Typography>
            {LanguageConverterV2(
              'timekeeping.workerTimecard.timecardHistoryCard.timeFieldLabel.hours',
              {
                hours: isValidNumber(dailyHours)
                  ? (dailyHours / (1000 * 60 * 60)).toFixed(2)
                  : '--',
              }
            )}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
HistoryTimeFields.propTypes = {
  labelKey: PropTypes.string,
  clockOutEpoch: PropTypes.number,
  clockInEpoch: PropTypes.number,
  breakTime: PropTypes.number,
  dailyHours: PropTypes.number,
  showClockInAutoPunch: PropTypes.bool,
  showClockOutAutoPunch: PropTypes.bool,
};
export default HistoryTimeFields;
